import { useQuery } from "@tanstack/react-query";
import { QueryModule } from "@/data/queryModules";
import { AppQueryOptions } from "@povio/openapi-codegen-cli";
import { ProfileAnalyticsModels } from "./profileAnalytics.models";
import { ProfileAnalyticsApi } from "./profileAnalytics.api";

export namespace ProfileAnalyticsQueries {

export const moduleName = QueryModule.ProfileAnalytics;

export const keys = {
    all: [moduleName] as const,
    getGradeScore: () => [...keys.all, "/profile-analytics/grade", ] as const,
    getCompletion: () => [...keys.all, "/profile-analytics/completion", ] as const,
    getSkillDiagram: () => [...keys.all, "/profile-analytics/skill-diagram", ] as const,
    getBlsSkillIndustry: () => [...keys.all, "/profile-analytics/bls-skill-industry", ] as const,
    getStrengthsWeaknesses: () => [...keys.all, "/profile-analytics/strengths-weaknesses", ] as const,
    getActionPrioritiesV2: (size?: number, strategy?: ProfileAnalyticsModels.GetActionPrioritiesV2StrategyParam, ) => [...keys.all, "/profile-analytics/action-priorities-v2", size, strategy] as const,
    getIndustryFitRank: () => [...keys.all, "/profile-analytics/industry-fit-rank", ] as const,
};


 /** 
 * Query `useGetGradeScore`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileAnalyticsGradeResponseDto> } 
 * @statusCodes [200, 401]
 */
export const useGetGradeScore = <TData>(options?: AppQueryOptions<typeof ProfileAnalyticsApi.getGradeScore, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getGradeScore(),
    queryFn: ProfileAnalyticsApi.getGradeScore
    ,
    ...options,
  });
};






 /** 
 * Query `useGetCompletion`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileAnalyticsCompletionResponseDto> } 
 * @statusCodes [200, 401, 403]
 */
export const useGetCompletion = <TData>(options?: AppQueryOptions<typeof ProfileAnalyticsApi.getCompletion, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getCompletion(),
    queryFn: ProfileAnalyticsApi.getCompletion
    ,
    ...options,
  });
};






 /** 
 * Query `useGetSkillDiagram`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileAnalyticsSkillDiagramResponseDto> } 
 * @statusCodes [200, 401, 403]
 */
export const useGetSkillDiagram = <TData>(options?: AppQueryOptions<typeof ProfileAnalyticsApi.getSkillDiagram, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getSkillDiagram(),
    queryFn: ProfileAnalyticsApi.getSkillDiagram
    ,
    ...options,
  });
};






 /** 
 * Query `useGetBlsSkillIndustry`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileBlsSkillIndustryResponseDto> } 
 * @statusCodes [200, 401]
 */
export const useGetBlsSkillIndustry = <TData>(options?: AppQueryOptions<typeof ProfileAnalyticsApi.getBlsSkillIndustry, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getBlsSkillIndustry(),
    queryFn: ProfileAnalyticsApi.getBlsSkillIndustry
    ,
    ...options,
  });
};






 /** 
 * Query `useGetStrengthsWeaknesses`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileAnalyticsStrengthsWeaknessesResponseDto> } 
 * @statusCodes [200, 401, 403]
 */
export const useGetStrengthsWeaknesses = <TData>(options?: AppQueryOptions<typeof ProfileAnalyticsApi.getStrengthsWeaknesses, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getStrengthsWeaknesses(),
    queryFn: ProfileAnalyticsApi.getStrengthsWeaknesses
    ,
    ...options,
  });
};






 /** 
 * Query `useGetActionPrioritiesV2`
 * @param { number } object.size Query parameter
 * @param { ProfileAnalyticsModels.GetActionPrioritiesV2StrategyParam } object.strategy Query parameter
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileAnalyticsActionPrioritiesV2ResponseDto> } 
 * @statusCodes [200, 401, 403]
 */
export const useGetActionPrioritiesV2 = <TData>({ size, strategy }: { size?: number, strategy?: ProfileAnalyticsModels.GetActionPrioritiesV2StrategyParam,  }, options?: AppQueryOptions<typeof ProfileAnalyticsApi.getActionPrioritiesV2, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getActionPrioritiesV2(size, strategy),
    queryFn: () =>  
    
    ProfileAnalyticsApi.getActionPrioritiesV2(size, strategy)
    ,
    ...options,
  });
};






 /** 
 * Query `useGetIndustryFitRank`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<ProfileAnalyticsModels.ProfileAnalyticsIndustryFitRankResponseDto> } 
 * @statusCodes [200, 401, 403]
 */
export const useGetIndustryFitRank = <TData>(options?: AppQueryOptions<typeof ProfileAnalyticsApi.getIndustryFitRank, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getIndustryFitRank(),
    queryFn: ProfileAnalyticsApi.getIndustryFitRank
    ,
    ...options,
  });
};






}
